// FILECONTENT_START src/common/components/Headers/index.ts
import Header from "./Header";
export default Header;
export type { HeaderProps } from "./Header";

// FILECONTENT_END src/common/components/Headers/index.ts